"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFederalOnSiteCap = getFederalOnSiteCap;
const wasteGeneratorStatusThresholds_1 = require("encamp-shared/dist/constants/wasteGeneratorStatusThresholds");
const UNCAPPED = { totalKg: null, nonAcuteKg: null, acuteKg: null };
function getFederalOnSiteCap(generatorStatus) {
    switch (generatorStatus) {
        case "VSQG":
            return { totalKg: null, nonAcuteKg: wasteGeneratorStatusThresholds_1.VSQG_ON_SITE_CAP_KG, acuteKg: wasteGeneratorStatusThresholds_1.VSQG_ON_SITE_ACUTE_CAP_KG };
        case "SQG":
            return { totalKg: wasteGeneratorStatusThresholds_1.SQG_ON_SITE_CAP_KG, nonAcuteKg: null, acuteKg: null };
        // LQGs have no quantity cap; an unresolvable status gets no cap either —
        // the caller prompts for setup rather than assuming a status.
        default:
            return UNCAPPED;
    }
}
//# sourceMappingURL=onSiteCaps.js.map